interface PdfPagePlaceholderProps {
  width: number;
  height: number;
  pageNumber: number;
  darkMode: boolean;
}

export function PdfPagePlaceholder({
  width,
  height,
  pageNumber,
  darkMode,
}: PdfPagePlaceholderProps) {
  return (
    <div
      className={`flex w-full justify-center py-4 ${
        darkMode ? "bg-neutral-900" : "bg-muted/30"
      }`}
    >
      <div
        className="shadow-lg rounded-md bg-muted/50 flex items-center justify-center"
        style={{
          width: `${width}px`,
          height: `${height}px`,
        }}
      >
        <span className="text-muted-foreground text-sm">
          Page {pageNumber}
        </span>
      </div>
    </div>
  );
}
